import BaseService from '@/services/base.service';
import {setToken} from "@/services/axios";

const API_URL = process.env.VUE_APP_API_URL;

class AccountService extends BaseService {
    transactions(page: number) {
        return this.get(API_URL+'/account/api/transactions?page='+page).then((response) => {
            const status = response.data.status;
            if (status === 'success') {
                return response.data.data;
            }

            return false;
        });
    }

    overview(page: number) {
        return this.get(API_URL+'/account/api/overview?page='+page).then((response) => {
            const status = response.data.status;
            if (status === 'success') {
                return response.data.data;
            }

            return false;
        });
    }

    notifications(page: number) {
        return this.get(API_URL+'/account/api/notifications?page='+page).then((response) => {
            const status = response.data.status;
            if (status === 'success') {
                return response.data.data;
            }

            return false;
        });
    }

    myDetails() {
        return this.get(API_URL+'/account/api/myDetails').then((response) => {
            const status = response.data.status;
            if (status === 'success') {
                return response.data.data;
            }

            return false;
        });
    }

    replyTransaction(betId: number) {
        return this.post(API_URL+'/lotto/api/replyTransaction', { betId })
            .then((response) => {
                const status = response.data.status;
                if (status === 'success') {
                    return response.data;
                }

                return response.data;
            });
    }

    saveMyDetails(firstName: string, lastName: string) {
        return this.post(API_URL+'/account/api/myDetails', {firstName, lastName}).then((response) => {
            const status = response.data.status;
            if (status === 'success') {
                return response.data;
            }

            return response.data;
        });
    }

    updatePassword(currentPassword: string, newPassword: string, confirmPassword: string) {
        return this.post(API_URL+'/account/api/changePassword', {currentPassword, newPassword, confirmPassword}).then((response) => {
            const status = response.data.status;
            if (status === 'success') {
                return response.data;
            }

            return response.data;
        });
    }

    payout(amount: number, reference: string) {
        return this.post(API_URL+'/pos/api/payout', { amount, reference })
            .then((response) => {
                const status = response.data.status;
                if (status === 'success') {
                    return response.data;
                }

                return response.data;
            });
    }
}

export default new AccountService();